import { useContext, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { Context } from "../hooks/useAuthContext";
import FullScreenLoader from "../components/FullScreenLoader/FullScreenLoader";

const Private = ({ children, role }) => {
  const { loading, setLoading, userData } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!userData && !loading) {
      navigate("/login");
      return;
    }

    const tiposAdmin = [
      "administrador",
      "automacao",
      "gestor",
      "financeiro",
      "coordenacao",
    ];
    if (role && !role.includes(userData.tipoConta)) {
      const destino = tiposAdmin.includes(userData.tipoConta) ? "/admin" : "/";
      setLoading(false);
      navigate(destino);
    }
  }, [loading, userData, navigate, role]);

  if (loading) {
    return (
      <center>
        <div>
          {" "}
          <FullScreenLoader />{" "}
        </div>
      </center>
    );
  }

  return userData ? children : null;
};

export { Private };
